import * as actiontypes from '../../constants/actionType';
import {RuntimeStateType} from '../../constants/actionType';
import {RuntimeNotificationType} from '../../constants/dataEnum';

// global variable
let timeout;

export function setRuntimeProtocolId(id) {
  return (dispatch) => {
    dispatch({
      type: actiontypes.SET_RUNTIME_PROTOCOL_ID,
      id,
    });
  };
}

export function setRuntimeProtocolName(protocolName) {
  return (dispatch) => {
    dispatch({
      type: actiontypes.SET_RUNTIME_PROTOCOL_NAME,
      protocolName,
    });
  };
}

export function setRuntimeStatus(status) {
  return (dispatch) => {
    dispatch({
      type: actiontypes.SET_RUNTIME_STATUS,
      status,
    });
  };
}

export function setRuntimeProgress(progress) {
  return (dispatch, getState) => {
    const {runtimeState} = getState();
    if (runtimeState.progress !== progress) {
      dispatch({
        type: actiontypes.SET_RUNTIME_PROGRESS,
        progress,
      });
    }
  };
}

export function setRuntimePauseRemainingTime(pause) {
  return (dispatch) => {
    dispatch({
      type: actiontypes.SET_RUNTIME_PAUSE_REMAINING_TIME,
      pause,
    });
  };
}

export function setRuntimeRemainingTime(remainingTime) {
  return (dispatch) => {
    dispatch({
      type: actiontypes.SET_RUNTIME_REMAINING_TIME,
      remainingTime,
    });
  };
}

export function setCsvRecordID(csvRecordID) {
  return (dispatch, getState) => {
    const {runtimeState} = getState();

    if (runtimeState.csvRecordID !== csvRecordID) {
      dispatch({
        type: actiontypes.SET_CSV_RECORD_ID,
        csvRecordID,
      });
    }
  };
}

export function hideRuntimeDialog() {
  return {type: actiontypes.HIDE_RUNTIME_DIALOG};
}

export const showRuntimeDialog =
  (dialog, timeOut = 3000, alwaysShow = false) =>
  (dispatch) => {
    dispatch({type: actiontypes.SHOW_RUNTIME_DIALOG, dialog});

    if (dialog.type !== RuntimeNotificationType.ERROR && !alwaysShow) {
      // TODO: this logic can be moved to component level
      timeout = setTimeout(() => dispatch(hideRuntimeDialog()), timeOut);
    } else {
      clearTimeout(timeout);
    }
  };

export function setPausedOn(pausedOn) {
  return (dispatch) => {
    dispatch({
      type: actiontypes.SET_PAUSED_ON,
      pausedOn,
    });
  };
}

export function addOnProgressRecord(onProgressRecordCSVIDs) {
  return (dispatch, getState) => {
    const {runtimeState} = getState();

    if (!runtimeState.onProgressRecordCSVIDs.includes(onProgressRecordCSVIDs)) {
      dispatch({
        type: actiontypes.ADD_ON_PROGRESS_RECORD,
        onProgressRecordCSVIDs,
      });
    }
  };
}

export function removeOnProgressRecord(onProgressRecordCSVIDs) {
  return (dispatch) => {
    dispatch({
      type: actiontypes.REMOVE_ON_PROGRESS_RECORD,
      onProgressRecordCSVIDs,
    });
  };
}

export function addDoneRecord(newDoneRecordCSVIDs) {
  return (dispatch, getState) => {
    const {runtimeState} = getState();

    if (!runtimeState.doneRecordCSVIDs.includes(newDoneRecordCSVIDs)) {
      dispatch({
        type: actiontypes.ADD_DONE_RECORD,
        newDoneRecordCSVIDs,
      });
    }
  };
}

export function setAbortParam(abortParam) {
  return (dispatch) => {
    dispatch({
      type: actiontypes.SET_ABORT_PARAM,
      abortParam,
    });
  };
}

export function restoreRuntimeState(state) {
  return (dispatch) => {
    dispatch({
      type: actiontypes.RESTORE_RUNTIMESTATE,
      state,
    });
  };
}

export function resetRuntimeState() {
  return {
    type: actiontypes.RESET_RUNTIMESTATE,
  };
}

export function setRuntimeReportVisible(visible) {
  return (dispatch) => {
    dispatch({
      type: actiontypes.SET_RUNTIME_REPORT_VISIBLE,
      data: visible,
    });
  };
}

export function setReadOnly(readOnly) {
  return {type: actiontypes.SET_READ_ONLY, readOnly};
}

export function setRuntimeUser(userExecutor) {
  return {type: actiontypes.SET_RUNTIME_USER, userExecutor};
}

export function setRuntimeAbortRequester(userRequester) {
  return {type: actiontypes.SET_RUNTIME_ABORT_USER_REQUESTER, userRequester};
}

export function setRuntimeIsTessaraProtocol(isTessaraProtocol) {
  return {type: actiontypes.SET_RUNTIME_TESSARA_PROTOCOL, isTessaraProtocol};
}

export function setRuntimeType(runtimeType) {
  return {type: actiontypes.SET_RUNTIME_TYPE, runtimeType};
}

export function setExecutionCount(count) {
  return {type: RuntimeStateType.SET_EXECUTION_COUNT, count};
}

export function setRuntimeTrayType(data) {
  return (dispatch) => {
    dispatch({
      type: actiontypes.SET_RUNTIME_TRAY_TYPE,
      data,
    });
  };
}
